import { render, staticRenderFns } from "./NsfwMask.vue?vue&type=template&id=b74f157c&"
import script from "./NsfwMask.vue?vue&type=script&lang=js&"
export * from "./NsfwMask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports